export const CUSTOMERS_LIST = "CUSTOMERS_LIST";
export const CUSTOMERS_LIST_SUCCESS = "CUSTOMERS_LIST_SUCCESS";
export const CUSTOMERS_LIST_FAIL = "CUSTOMERS_LIST_FAIL";

/* >>>>>>>>>>>>>> EDIT CUSTOMER >>>>>>>>>>>>>>>*/

export const EDIT_CUSTOMER = "EDIT_CUSTOMER";
export const EDIT_CUSTOMER_SUCCESS = "EDIT_CUSTOMER_SUCCESS";
export const EDIT_CUSTOMER_FAIL = "EDIT_CUSTOMER_FAIL";

/* >>>>>>>>>>>Update User <<<<<<<<<<<<<<< */
export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL";

/* >>>>>>>>Add User <<<<<<<<<<<<<<< */
export const ADD_USER = "ADD_USER";
export const ADD_USER_SUCCESS = "ADD_USER_SUCCESS";
export const ADD_USER_FAIL = "ADD_USER_FAIL";

/* >>>>>>>>>>>BLOCK_UNBLOCK_USER <<<<<<<<<<<<<<< */
export const BLOCK_UNBLOCK_USER = "BLOCK_UNBLOCK_USER";
export const BLOCK_UNBLOCK_USER_SUCCESS = "BLOCK_UNBLOCK_USER_SUCCESS";
export const BLOCK_UNBLOCK_USER_FAIL = "BLOCK_UNBLOCK_USER_FAIL";

/* >>>>>>>>>>>>>> DELETE USER >>>>>>>>>>>>>>>*/
export const DELETE_USER = "DELETE_USER";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAIL = "DELETE_USER_FAIL";

/* >>>>>>>>>>>>>> SEND EMAIL >>>>>>>>>>>>>>>*/
export const SEND_EMAIL = "SEND_EMAIL";
export const SEND_EMAIL_SUCCESS = "SEND_EMAIL_SUCCESS";
export const SEND_EMAIL_FAIL = "SEND_EMAIL_FAIL";

/* >>>>>>>>>>>>>> SEND SMS >>>>>>>>>>>>>>>*/
export const SEND_TEXT = "SEND_TEXT";
export const SEND_TEXT_SUCCESS = "SEND_TEXT_SUCCESS";
export const SEND_TEXT_FAIL = "SEND_TEXT_FAIL";

/* >>>>>>>>>>>>>> POST DOCUMENT FILE >>>>>>>>>>>>>>>*/
export const POST_DOCUMENT_FILE = "POST_DOCUMENT_FILE";
export const POST_DOCUMENT_FILE_SUCCESS = "POST_DOCUMENT_FILE_SUCCESS";
export const POST_DOCUMENT_FILE_FAIL = "POST_DOCUMENT_FILE_FAIL";

/* >>>>>>>>>>>>>> DELETE USER DOCUMENT >>>>>>>>>>>>>>>*/
export const DELETE_USER_DOCUMENT = "DELETE_USER_DOCUMENT";
export const DELETE_USER_DOCUMENT_SUCCESS = "DELETE_USER_DOCUMENT_SUCCESS";
export const DELETE_USER_DOCUMENT_FAIL = "DELETE_USER_DOCUMENT_FAIL";

/* >>>>>>>>>>>>>> UPDATE DOCUMENT FILE >>>>>>>>>>>>>>>*/
export const UPDATE_DOCUMENT_FILE = "UPDATE_DOCUMENT_FILE";
export const UPDATE_DOCUMENT_FILE_SUCCESS = "UPDATE_DOCUMENT_FILE_SUCCESS";
export const UPDATE_DOCUMENT_FILE_FAIL = "UPDATE_DOCUMENT_FILE_FAIL";

/* >>>>>>>>>>>>>> GET DOCUMENT FILE >>>>>>>>>>>>>>>*/
export const GET_DOCUMENT_FILE = "GET_DOCUMENT_FILE";
export const GET_DOCUMENT_FILE_SUCCESS = "GET_DOCUMENT_FILE_SUCCESS";
export const GET_DOCUMENT_FILE_FAIL = "GET_DOCUMENT_FILE_FAIL";

/* >>>>>>>>>>>>>> GET DOCUMENT FILE >>>>>>>>>>>>>>>*/
export const ACCEPT_REJECT_DOCUMENT = "ACCEPT_REJECT_DOCUMENT";
export const ACCEPT_REJECT_DOCUMENT_SUCCESS = "ACCEPT_REJECT_DOCUMENT_SUCCESS";
export const ACCEPT_REJECT_DOCUMENT_FAIL = "ACCEPT_REJECT_DOCUMENT_FAIL";

/* >>>>>>>>>>>>>> SEND DOCUMENT LIST >>>>>>>>>>>>>>>*/
export const SEND_DOCUMENTS_LIST = "SEND_DOCUMENTS_LIST";
export const SEND_DOCUMENTS_LIST_SUCCESS = "SEND_DOCUMENTS_LIST_SUCCESS";
export const SEND_DOCUMENTS_LIST_FAIL = "SEND_DOCUMENTS_LIST_FAIL";

/* >>>>>>>>>>>>>> CHANGE PASSWORD >>>>>>>>>>>>>>>*/
export const RESET_USER_PASS = "RESET_USER_PASS";
export const RESET_USER_PASS_SUCCESS = "RESET_USER_PASS_SUCCESS";
export const RESET_USER_PASS_FAIL = "RESET_USER_PASS_FAIL";

/* >>>>>>>>>>>>>> ADD NOTE >>>>>>>>>>>>>>>*/
export const ADD_NOTE = "ADD_NOTE";
export const ADD_NOTE_SUCCESS = "ADD_NOTE_SUCCESS";
export const ADD_NOTE_FAIL = "ADD_NOTE_FAIL";

/* >>>>>>>>>>>>>> GET NOTE >>>>>>>>>>>>>>>*/
export const GET_NOTE_BY_ID = "GET_NOTE_BY_ID";
export const GET_NOTE_BY_ID_SUCCESS = "GET_NOTE_BY_ID_SUCCESS";
export const GET_NOTE_BY_ID_FAIL = "GET_NOTE_BY_ID_FAIL";

/* >>>>>>>>>>>>>> UPDATE NOTE >>>>>>>>>>>>>>>*/
export const UPDATE_NOTE = "UPDATE_NOTE";
export const UPDATE_NOTE_SUCCESS = "UPDATE_NOTE_SUCCESS";
export const UPDATE_NOTE_FAIL = "UPDATE_NOTE_FAIL";

/* >>>>>>>>>>>>>> SINGLE NOTE >>>>>>>>>>>>>>>*/
export const GET_SINGLE_NOTE = "GET_SINGLE_NOTE";
export const GET_SINGLE_NOTE_SUCCESS = "GET_SINGLE_NOTE_SUCCESS";
export const GET_SINGLE_NOTE_FAIL = "GET_SINGLE_NOTE_FAIL";

/* >>>>>>>>>>>>>> DELETE NOTE >>>>>>>>>>>>>>>*/
export const DELETE_NOTE = "DELETE_NOTE";
export const DELETE_NOTE_SUCCESS = "DELETE_NOTE_SUCCESS";
export const DELETE_NOTE_FAIL = "DELETE_NOTE_FAIL";

/* >>>>>>>>>>>>>> SMS HISTORY >>>>>>>>>>>>>>>*/
export const SMS_HISTORY = "SMS_HISTORY";
export const SMS_HISTORY_SUCCESS = "SMS_HISTORY_SUCCESS";
export const SMS_HISTORY_FAIL = "SMS_HISTORY_FAIL";

/* >>>>>>>>>>>>>> ADD_EMAIL_DRAFT >>>>>>>>>>>>>>>*/
export const ADD_EMAIL_DRAFT = "ADD_EMAIL_DRAFT";
export const ADD_EMAIL_DRAFT_SUCCESS = "ADD_EMAIL_DRAFT_SUCCESS";
export const ADD_EMAIL_DRAFT_FAIL = "ADD_EMAIL_DRAFT_FAIL";

/* >>>>>>>>>>>>>> draft email list >>>>>>>>>>>>>>>*/
export const DRAFT_EMAIL_LIST = "DRAFT_EMAIL_LIST";
export const DRAFT_EMAIL_LIST_SUCCESS = "DRAFT_EMAIL_LIST_SUCCESS";
export const DRAFT_EMAIL_LIST_FAIL = "DRAFT_EMAIL_LIST_FAIL";

/* >>>>>>>>>>>>>> draft email by id >>>>>>>>>>>>>>>*/
export const DRAFT_EMAIL_BY_ID = "DRAFT_EMAIL_BY_ID";
export const DRAFT_EMAIL_BY_ID_SUCCESS = "DRAFT_EMAIL_BY_ID_SUCCESS";
export const DRAFT_EMAIL_BY_ID_FAIL = "DRAFT_EMAIL_BY_ID_FAIL";
